import {
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

export default function Emptydata(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Check if the screen is small
  return (
    <Stack
      mt={0}
      className="empty-data"
      justifyContent={"center"}
      alignItems={"center"}
    >
      {props?.icon}
      <Stack spacing={1} pt={1}>
      <Typography color="textSecondary" className="empty-text ">
        {props?.firstText}
      </Typography>
      <Typography color="textSecondary" className="empty-text ">
        {props?.secondText}
      </Typography>
      {props?.buttonText && (
        <Button
          sx={{
            width: isMobile ? "100%" : "auto", // Full-width button on mobile
          }}
          variant="contained"
          className="action-button"
          onClick={props.onButtonClick}
        >
          {props?.buttonText}
        </Button>
        )}
        </Stack>
    </Stack>
  );
}
